import * as React from "react"
import "./style_4.scss";

export default function ProductAccordionContentStyle4({infoBlock}) {

    return (
        <div className={`accordion-content-block style_4  label_${infoBlock.label} ${infoBlock.style}`}>
            <div className={`content-block-image`}>
                <img src={infoBlock.image} alt=""/>
            </div>
            <div className={`content-block-info`}>
                <h3>{infoBlock.label}</h3>
                <h4>
                    {infoBlock.url ?
                        (<a target={`_blank`} href={infoBlock.url}>{infoBlock.value}</a>):
                        (<span>{infoBlock.value}</span>)}
                </h4>
            </div>
        </div>
    )
}
